import type { AdverseEventReason, MilestoneStatus } from './types';

export const LEGAL_MODEL_ASSUMPTIONS = [
  '原协议将“里程碑逐项成熟”与第1.4条三年分期成熟/vesting及统一行权机制区分处理。',
  'M1既是第1.3(1)项0.2%里程碑，也是第3.3条项下全部孵化权益/认股权的前置合规门槛。',
  '冲突清理未完成时，可以保存其他里程碑模拟输入，但不得计入乙方可主张的有效孵化权益。',
  '本模型按第5.5条解释：协议终止、乙方停止提供服务、未达成里程碑或未配合行权手续时，未成熟或未行权部分自动失效。',
  '非因乙方重大违约但合作终止或乙方停止服务时，已行权或已实际取得的权益进入上一轮融资价格/估值80%回购风险。',
  '乙方重大违约、泄密、隐瞒利益冲突、违反竞业限制或服务/孵化竞争项目时，已行权或已实际取得的权益进入成本价或名义价格回购风险。',
  '这是法律设计实验模型，不构成法律意见；真实适用仍需结合完整协议、事实、通知、豁免及正式公司文件。',
];

export const ADVERSE_EVENT_LABELS: Record<AdverseEventReason, string> = {
  none: '无不利事件',
  ordinary_termination: '普通终止/合作终止',
  service_stopped: '乙方停止提供服务',
  major_breach: '乙方重大违约',
  confidentiality_breach: '违反保密/不使用义务',
  undisclosed_conflict: '未披露利益冲突',
  non_compete_breach: '违反竞业限制',
  competing_project: '服务或孵化竞争项目',
};

export const STATUS_LABELS: Record<MilestoneStatus, string> = {
  blocked: '前置限制未清理',
  pending: '尚未达成',
  future: '达成日在未来',
  earned: '里程碑已取得',
  vesting: '时间归属中',
  exercisable: '可行权',
  exercised: '已行权',
  lapsed: '已失效',
  repurchase_80_risk: '80% 回购风险',
  repurchase_nominal_risk: '名义价回购风险',
};

export const STATUS_TONE: Record<MilestoneStatus, string> = {
  blocked: 'blocked',
  pending: 'pending',
  future: 'pending',
  earned: 'earned',
  vesting: 'vesting',
  exercisable: 'success',
  exercised: 'success',
  lapsed: 'danger',
  repurchase_80_risk: 'warning',
  repurchase_nominal_risk: 'danger',
};
